import React from "react";
import { LogPageViewParams } from "@pepdirect/v3/types";
import { CartFragment, VariantFragment } from "services/graphql/generated";

export interface LogContextValueInterface {
  useLogPageView: (
    _params: LogPageViewParams,
    _product?: VariantFragment | null,
    _cart?: CartFragment | null,
    _key?: string
  ) => void;
}

export const LogContext = React.createContext<LogContextValueInterface>({
  useLogPageView: (
    _params: LogPageViewParams,
    _product?: VariantFragment | null,
    _cart?: CartFragment | null,
    _key?: string
  ) => {},
});
